//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { withRouter } from "found";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// login-wrapper imports
import { IProps, IState, IContainer } from "./LoginWrapper.d";
import { loginWrapperFragments, loginWrapperQuery } from "./LoginWrapper.gql";
import { LoginDefault } from "./login-default";
import { LoginInvite } from "./login-invite";
import { LoginWelcome } from "./login-welcome";
// state
import { IReduxState } from "@reducers/root.reducer";
import { withRouteQuery } from "@routing/routes.util";

//////////////////
// COMPONENT
//////////////////
class LoginWrapperCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    let redirect;
    if (this.props.match && this.props.match.params && this.props.match.params.redirect) {
      redirect = this.props.match.params.redirect;
      if (window.location && window.location.search) {
        redirect += window.location.search;
      }
    }

    const isClockwiseUser = JSON.parse(localStorage.getItem("CwUser") || "false");

    switch (this.props.variant) {
      case "invite":
        return <LoginInvite viewer={this.props.viewer} redirect={redirect} />;
      case "welcome":
        return <LoginWelcome viewer={this.props.viewer} redirect={redirect} />;
      case "welcome-ambiguous":
        return <LoginWelcome viewer={this.props.viewer} redirect={redirect} ambiguous={true} />;
      case "default":
      default:
        if (!isClockwiseUser) {
          return <LoginWelcome viewer={this.props.viewer} redirect={redirect} />;
        } else {
          return <LoginDefault viewer={this.props.viewer} redirect={redirect} />;
        }
    }
  }
}

//////////////////
// REDUX
//////////////////
const LoginWrapperWithRouter = withRouter(LoginWrapperCmpt);

function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {})(LoginWrapperWithRouter);

//////////////////
// RELAY
//////////////////
export const LoginWrapper = createFragmentContainer<IContainer>(
  reduxContainer,
  loginWrapperFragments,
);

export const LoginWrapperPage = withRouteQuery(LoginWrapper, loginWrapperQuery);
